import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthWebService } from 'app/services/authweb.service';
import { environment } from '../../environments/environment';


@Component({
  selector: 'support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  phonenumber: string ;
  email: string;
  contactdetails;
  constructor(private authWebService: AuthWebService,
    private router: Router, private sanitizer: DomSanitizer,
    private activRoute: ActivatedRoute) { }

  ngOnInit() {
    this.setContactPage();
  }

  setContactPage(){
    this.authWebService.webrequest('GET','ConfigurationService', 'SystemConfig', JSON.stringify({
      systemCode: environment.authWebApi.systemCode
    })).then((data) => {
      environment.authWebApi.systemData = data;
      let html = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'ICBMSContact1');
      if (html) {
        this.contactdetails = this.sanitizer.bypassSecurityTrustHtml(html.Value);
      } else {
        this.contactdetails = "<p>Phone Number: +27 (0)12 471 2121 </br> Email: <a href=\"mailto:customercare@cbrta.co.za\"> customercare@cbrta.co.za </a> customercare@cbrta.co.za </p>";
      }

      ////console.log( environment.authWebApi.userData )
    }, (error) => {
      //console.log(error)
    });
  }
}
